import { render, staticRenderFns } from "./video.vue?vue&type=template&id=7119e56c&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports